import outerSelected from '@/assets/images/frame/share.svg';
import { DrawPlayerImage } from '@/utils/drawing';
import clsx from 'clsx';
import { Stage as RStage } from 'konva/lib/Stage';
import { forwardRef, useRef } from 'react';
import { Group, Image as KImage, Layer, Stage, Text } from 'react-konva';
import { ASPECT_RATIO } from './Canvas';

interface CanvasProps {
  prompt: string;
  drawing: LineProps[];
}

export interface LineProps {
  points: number[];
  stroke: string;
  width: number;
  tool: string;
  canvasWidth: number;
  canvasHeight: number;
}

// The aspect ratio of the canvas is to the ratio of the background image
// used when the canvas is in viewer mode. This helps with consistent scaling
// of the drawing when the canvas is resized.
const EDGE_PADDING = 80;

const CanvasShare = forwardRef<RStage, CanvasProps>(({ prompt, drawing }, ref) => {
  const backgroundSize = {
    width: 829,
    height: 1473
  };

  const canvasSize = {
    width: backgroundSize.width - EDGE_PADDING,
    height: (backgroundSize.width - EDGE_PADDING) / ASPECT_RATIO
  };

  const layerRef = useRef<HTMLDivElement>(null);

  const cardFrameOuterSelected = new Image();
  cardFrameOuterSelected.src = outerSelected;

  return (
    <div className="hidden">
      <div
        className={clsx(
          'flex items-center justify-center',
          'relative touch-none w-full h-full rounded-3xl max-w-lg'
        )}
      >
        <div ref={layerRef} className={clsx('w-[90%] h-[90%]')}>
          <Stage
            ref={ref}
            className="w-full h-full"
            width={backgroundSize.width}
            height={backgroundSize.height}
          >
            <Layer>
              <KImage
                image={cardFrameOuterSelected}
                x={backgroundSize.width / 2 - backgroundSize.width / 2}
                y={backgroundSize.height / 2 - backgroundSize.height / 2}
                width={backgroundSize.width}
                height={backgroundSize.height}
              />
              <Group x={backgroundSize.width / 2} y={backgroundSize.height / 2}>
                <Text
                  text={prompt}
                  align="center"
                  fontSize={42}
                  fill="#fff"
                  fontStyle="bold"
                  y={-canvasSize.height / 2 - 120}
                  width={canvasSize.width - 40}
                  wrap="word"
                  x={-canvasSize.width / 2}
                />
                <DrawPlayerImage
                  drawing={drawing}
                  cardSize={{
                    width: canvasSize.width,
                    height: canvasSize.height
                  }}
                />
              </Group>
            </Layer>
          </Stage>
        </div>
      </div>
    </div>
  );
});

CanvasShare.displayName = 'Canvas';

export default CanvasShare;
